import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledReactTable from 'components/molecules/StyledReactTable';
import CellDiv from 'components/molecules/tables/components/CellDiv';

const INDENT_PADDING = 20; // padding for the hierarchy depth

const HierarchyIconWrap = styled('div')`
    color: #C4C4C4;
    float: left;
    height: 100%;
    padding: 0 5px 0 0;
    margin-top: -4px;
`;

class EntityChildrenTable extends Component {
    getColumns() {
        return [
            {
                Header: 'NAME',
                headerClassName: '-alignLeft',
                accessor: 'name',
                Cell: props => this.viewUserLink(null, props.original),
                sortable: false,
                resizable: false,
            }, {
                Header: 'LAYER ALIAS',
                headerClassName: '-alignLeft',
                accessor: 'aliasName',
                Cell: row => <CellDiv value={row.value} />,
                sortable: false,
                resizable: false,
                maxWidth: 300
            }
        ];
    }

    viewUserLink(cell, row) {
        return (
            <Link to={`/admin/entities/${row.id}`} title="Go to Entity">
                {row.depth > 0 ? [
                    <HierarchyIconWrap key={0} style={{ paddingLeft: `${row.depth * INDENT_PADDING}px` }} className="icon-hierarchy" />,
                    <div key={1} style={{ marginLeft: `${(row.depth * INDENT_PADDING) + 13}px` }}>{row.name}</div>
                ] :
                    <div>{row.name}</div>
                }
            </Link>
        );
    }

    render() {
        return <StyledReactTable
            data={this.props.data}
            minRows={1}
            columns={this.getColumns()}
            className="-highlight"
            showPagination={false}
            defaultPageSize={99999}
            noDataText="No entities to display"
        />;
    }
}

EntityChildrenTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        aliasName: PropTypes.string.optional,
        depth: PropTypes.number.isRequired
    })).isRequired
};

export default EntityChildrenTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/EntityChildrenTable.js